module.exports = __webpack_public_path__ + "static/media/editIcon.a91e066d.svg";